/**
 * Prevents duplicate magic link authentication API calls caused by React Strict Mode
 * double-rendering in development.
 *
 * Uses a module-level singleton to track whether the magic link login has already
 * been initiated, preventing redundant API calls when the component re-renders.
 *
 * The exported instance includes a `reset()` method for test cleanup to prevent
 * cross-test state pollution.
 */
class MagicLinkRequestGuard {
  #hasBeenCalled: boolean = false;

  constructor() {
    this.clear();
  }

  clear() {
    this.#hasBeenCalled = false;
  }

  wasAlreadyCalled() {
    return this.#hasBeenCalled;
  }

  markAsCalled() {
    this.#hasBeenCalled = true;
  }

  reset() {
    this.clear();
  }
}

export const magicLinkRequestGuard = new MagicLinkRequestGuard();
